import PropTypes from 'prop-types'
import { Separator } from '@components/ui/separator'
import { cn } from 'lib/utils'

export const AdasDivider = ({
  className,
  orientation = 'horizontal',
  // eslint-disable-next-line no-unused-vars
  flexItem,
  // eslint-disable-next-line no-unused-vars
  variant,
  // eslint-disable-next-line no-unused-vars
  light,
  ...props
}) => <Separator orientation={orientation} className={cn('bg-divider', flexItem && 'self-stretch', className)} {...props} />

AdasDivider.propTypes = {
  className: PropTypes.string,
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
}
